<template>
  <div class="upload-container">
    <el-row v-if="showLimit">
      <el-col :span="24">
        <el-tag
          type="warning"
          style="height: auto; white-space: break-spaces; font-size: 14px; margin: 5px 0px"
          >{{ limitText ? limitText : '檔案限制不超過2000MB' }}</el-tag
        >
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <div id="uploadDiv">
          <el-upload
            ref="upload"
            :accept="accept"
            :data="dataObj"
            :auto-upload="autoUpload"
            :multiple="multiple"
            :show-file-list="showFileList"
            :btn-txt="btnTxt"
            :limit="limitFileCount"
            :on-change="fileChange"
            :on-exceed="handleExceed"
            :on-error="handleUploadError"
            :on-success="handleUploadSuccess"
            :before-upload="beforeUpload"
            :file-list="fileList"
            :on-remove="handleRemove"
            :on-preview="handlePreview"
            class="file-uploader"
            :drag="useDrag"
            :action="apiUrl"
            :btn-style="btnStyle"
            :show-limit="false"
          >
            <el-button size="mini" ref="selectedRef" :type="btnStyle">
              {{ btnTxt ? btnTxt : '選取檔案' }}
            </el-button>
            <!--<div slot="tip" class="el-upload__tip" v-if="showLimit">
            <template v-if="!limitText">
               {{
                accept
                  ? `只能上傳${accept}文件，且不超過2000mb`
                  : "檔案限制不超過2000mb"
              }}
            </template>
<template v-if="limitText">
              {{ limitText }}
            </template>
</div>-->

            <!-- <div v-if="useDrag">
            <i class="el-icon-upload" />
            <div class="el-upload__text">
              {{ "將文件拖到這裡，或" }}<em>{{ "點擊上傳" }}</em
              ><br />{{ "檔案格式不限，且單檔不能超過10m" }}
            </div>
          </div>
          <el-button
            v-else
            type="primary"
            :size="size"
            :loading="loading"
            :style="btnStyle"
          >
            <span v-if="btnTxt">{{ btnTxt }}</span>
            <span v-else>{{ "上傳檔案" }}</span>
            <i class="el-icon-upload el-icon--right"
          /></el-button> -->
          </el-upload>
        </div>
      </el-col>
    </el-row>
    <!-- <el-col :span="11" class="before-file-preview">
        <h5 style="margin: 10px">已上傳檔案</h5>

        <ul class="el-upload-list el-upload-list--text" style="margin: 10px">
          <li
            v-for="(f, index) in beforeFileList"
            :key="index"
            class="el-upload-list__item is-ready"
          >
            <a
              :href="f.urlPath"
              target="_blank"
              @click="downloadFile(f.id, f.fileName)"
            >
              <i class="el-icon-document"></i>
              {{ f.fileName }}</a
            >

            <label class="el-upload-list__item-status-label"
              ><i class="el-icon-upload-success el-icon-circle-check" /></label
            ><i class="el-icon-close" /><i class="el-icon-close-tip" />
          </li>
        </ul>
      </el-col> -->

    <!-- <span slot="footer" class="dialog-footer">
      <el-button style="margin-left: 10px;" type="success" @click="submitUpload"
        >数据导入</el-button
      >
    </span> -->
  </div>
</template>

<script>
import axios from 'axios'
import { getToken } from '@/utils/auth'
import { downloadAs } from '@/utils/funcs'
import { jsonToFormData, convertFileToBase64 } from '@/utils/funcs'
import request from '@/utils/request'

export default {
  name: 'FileUpload',
  props: {
    // 外部傳入的物件
    payload: {
      type: Object,
      default: null,
    },
    size: {
      type: String,
      default: 'medium',
    },
    accept: {
      type: String,
      default: '',
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    dataObj: {
      type: Object,
      default: { id: 0, type: '', user: '' },
    },
    btnStyle: {
      type: String,
      default: 'primary',
    },

    formOnLoadingParent: {
      required: false,
      default() {
        return () => this.formOnLoading()
      },
    },
    beforeFileList: {
      // 拿來存放已上傳檔案 並使用watch監聽加入原本的fileList 不用擔心物件屬性不同 forEach裡面定義新物件對應並加入即可。
      type: Array,
      default: () => [],
    },
    // 是否必要上傳
    require: {
      type: Boolean,
      default: false,
    },
    autoUpload: {
      type: Boolean,
      default: false,
    },
    showFileList: {
      type: Boolean,
      default: true,
    },
    useDrag: {
      type: Boolean,
      default: true,
    },
    action: {
      type: String,
      default: '',
    },
    btnTxt: {
      type: String,
      default: '',
    },
    limitFileCount: {
      type: Number,
      default: 3,
    },
    limitText: {
      type: String,
      default: null,
    },
    showLimit: {
      type: Boolean,
      default: true,
    },
    sendFileMsgCallback: {
      type: Function,
      default: () => null,
    },
  },
  data() {
    return {
      loading: false,
      beforeNotify: null,
      fileList: [], // 文件列表
    }
  },
  computed: {
    apiUrl() {
      return `${process.env.VUE_APP_BASE_API}/${this.action}/fileUpload`
    },
  },
  watch: {
    beforeFileList: {
      handler: function (newVal, oldVal) {
        const vm = this
        if (newVal) {
          newVal.forEach(f => {
            //debugger;
            const o = {
              name: f.fileName,
              percentage: 0,
              size: 0,
              status: 'success',
              uid: f.id,
            }
            vm.fileList.push(o)
          })
        }

        // debugger;
        // let reNewVal = JSON.parse(JSON.stringify(newVal));
        // if (reNewVal.length == 0) {
        //   vm.fileList = [];
        // } else {
        //   // watch it
        //   reNewVal.forEach((f) => {
        //     const o = {
        //       name: f.fileName,
        //       percentage: 0,
        //       size: 0,
        //       status: "success",
        //       uid: f.id,
        //     };
        //     vm.fileList.push(o);
        //   });
        // }
      },
      deep: true,
      immediate: true,
    },
  },
  created() {},
  methods: {
    clearFiles() {
      this.fileList = []
      if (this.$refs.upload) {
        this.$refs.upload.clearFiles()
      }
    },
    downloadFile(id, fileName) {
      downloadAs(id, fileName)
    },
    formOnLoading() {
      this.formOnLoadingParent(true)
      this.loading = true
    },
    formUnLoading() {
      this.formOnLoadingParent(false)
      this.loading = false
    },
    handleRemove(file) {
      const index = this.fileList.findIndex(item => item.uid === file.uid)
      this.fileList.splice(index, 1)
    },
    async handlePreview(f) {
      let url
      if (f.status == 'ready') {
        url = window.URL.createObjectURL(f.raw)
      } else if (f.status == 'success') {
        // 已上傳檔案click事件
        // url = `${process.env.VUE_APP_BASE_API}${f.url}`;
        await downloadAs(f.uid, f.name)
        return
      } else {
        return
      }

      window.URL = window.URL || window.webkitURL
      // const url = `${process.env.VUE_APP_BASE_API}${f.url}`;
      var xhr = new XMLHttpRequest()
      var a = document.createElement('a')
      var file
      xhr.open('GET', url, true)
      xhr.responseType = 'blob'
      xhr.onload = function () {
        file = new Blob([xhr.response], { type: 'application/octet-stream' })
        a.href = window.URL.createObjectURL(file)
        a.download = f.name // Set to whatever file name you want

        a.click()
      }
      xhr.send()
    },
    fileChange(file, fileList) {
      console.log('fileList', fileList)
      this.fileList = fileList
    },
    filterFiles(type, files) {
      let result = []
      switch (type) {
        case 1: // 未上傳檔案
          result = files.filter(f => {
            return typeof f.raw !== 'undefined'
          })
          break
        case 2: // 已上傳檔案ID
          files
            .filter(f => {
              return typeof f.raw === 'undefined'
            })
            .forEach(f => {
              result.push(f.uid)
            })

          break
      }
      return result
    },
    // 將傳進的payload與檔案結合 檔案格式為base64
    async combineFileAndPayload() {
      const vm = this
      if (vm.require && this.fileList.length <= 0) {
        this.$message.error('請先選擇需要上傳的檔案')
        return false
      }

      vm.payload.fileInfo = []
      vm.payload.fileIDs = []

      let fileType = 0
      let fileTypeChk = true

      //debugger;
      switch (vm.action) {
        case 'Agency/saveAgency':
          fileType = 4
          break
        case 'Coupon/saveCoupon':
          fileType = 5
          break
        case 'TravelSettings/saveGroupTour': // 上傳說明會
          fileType = 6
          break
        case 'TravelSettings/importTravelers': // 匯入旅客
          fileType = 9
          break
        case 'TravelSettings/saveGroupTourCommonForms': // 團體旅遊常用表單
          fileType = 10
          break
        case 'TravelSettings/commonFormsForTravel': // 旅遊團常用表單
          fileType = 44
          break
        case 'TravelSettings/TravelInfoAnalytics': // 智能分析旅程資訊
          fileType = 45
          break
        case 'TravelSettings/tourHandbook': // 行程手冊
          fileType = 12
          break
        case 'TravelSettings/uploadTravelers': // 上傳總表
          fileType = 36
          break
        case 'ToursCombine/saveArticle': // tc網文章封面照
          fileType = 15
          break
        case 'ToursCombine/saveIntroAvatar': // tc網會員簡介頭貼
          fileType = 17
          break
        case 'ToursCombine/saveIndexCarousel': // tc網首頁輪播圖電腦
          fileType = 18
          break
        case 'ToursCombine/saveHashTagGather': // tc網首頁hashtag集合
          fileType = 19
          break
        case 'ToursCombine/saveHotCountry': // tc網hotCountry設定
          fileType = 20
          break
        case 'ToursCombine/saveLeaderProfile': // tc網導遊領隊證照
          fileType = 21
          break
        case 'TravelSettings/saveKnowledgeArticle': // app新增知識
          fileType = 25
          break
        case 'appManage/saveFaultBack': // 後臺故障與回報檔案
          fileType = 26
          break
        case 'ToursCombine/saveIndexCarouselMobile': // tc網首頁輪播圖手機
          fileType = 34
          break
        case 'file/fileUpload': // 上傳簽署文件
          fileType = 40
          break
        case 'file/fileUploadAd': // 上傳廣告
          fileType = 42
          break
        case 'file/fileUploadLogo': // 上傳商家 logo
          fileType = 43
          break
        case 'Chat': // 即時訊息檔案上傳
          fileType = 99
          break
        default:
          fileTypeChk = false
          break
      }

      if (!fileTypeChk) {
        alert('未知的檔案類型，無法上傳。')
        return null
      }

      const filteFileReal = this.filterFiles(1, vm.fileList)
      const oldFileIDs = [...this.filterFiles(2, vm.fileList)]
      oldFileIDs.forEach(f => {
        // 舊檔案ID
        vm.payload.fileIDs.push(f)
      })

      const fileModel = {
        type: fileType,
        files: [],
      }

      for (var i = 0; i < filteFileReal.length; i++) {
        const f = filteFileReal[i]
        await convertFileToBase64(f.raw).then((resolve, reject) => {
          fileModel.files.push({
            fileName: f.name,
            base64: resolve,
          })
        })
      }
      vm.payload.fileInfo.push(fileModel)

      return vm.payload
    },
    // 提交上传文件
    submitFileForm() {
      const vm = this
      let success = false
      if (this.require && this.fileList.length <= 0) {
        this.$message.error('請先選擇需要上傳的文件')
        return false
      }
      // if (vm.fileList.length == 0) {
      //   return true;
      // }

      let sizeValid = true

      vm.fileList.forEach(file => {
        const isLt1M = file.size / (1024 * 1024) < 2000
        if (!isLt1M) {
          this.$message.error('上傳文件大小不能超過 2000MB!')
          sizeValid = false
          return false
        }
      })
      if (!sizeValid) {
        return sizeValid
      }

      const formData = new FormData()
      formData.append('id', vm.dataObj.id)
      formData.append('type', vm.dataObj.type)
      formData.append('user', vm.dataObj.user)

      vm.fileList.forEach(file => {
        if (file.status == 'ready') {
          formData.append('files', file.raw)
        } else if (file.status == 'success') {
          formData.append('beforeFiles', file.uid)
        }
      })

      axios
        .post(vm.apiUrl, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: 'Bearer ' + getToken(),
          },
        })
        .then(response => {
          success = response.data.success
          if (success) {
            vm.fileList.forEach(file => {
              file.status = 'success'
            })
          } else {
            this.$message.error(response.msg)
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error('上傳失敗!')
        })

      return true
    },
    handleExceed() {
      const vm = this
      this.$message.error(`檔案數請勿超過${this.limitFileCount}個`)
    },
    handleUploadError(response, file, fileList) {
      const vm = this
      this.formUnLoading()
      this.$message.error('上傳失敗')
    },
    handleUploadSuccess(response, file, fileList) {
      const vm = this
      vm.loading = false
      if (response.success) {
        if (this.dataObj.type == 'wareHouseQrcodeTransfer') {
          this.formUnLoading()
          this.$refs['upload'].clearFiles() // Clear files
          if (this.beforeNotify) {
            this.beforeNotify.close()
          }

          this.$notify({
            title: '通知',
            message: 'Excel轉換完成',
            type: 'success',
            duration: 5000,
          })

          const baseUrl = `${process.env.VUE_APP_BASE_API}/${this.action}/downloadCompress?fileName=${response.data}`
          axios({
            url: baseUrl,
            method: 'GET',
            responseType: 'blob', // important
            // timeout: 1000,
            headers: { Authorization: 'Bearer ' + getToken() },
          }).then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            let fName = response.headers['content-disposition'].split('filename=')[1]
            const findSub = fName.indexOf('.zip')
            fName = fName.substring(0, findSub) + '.zip'
            link.setAttribute('download', fName)
            document.body.appendChild(link)
            link.click()
          })
        } else if (this.dataObj.type == 'purchaseOrder') {
          this.$emit('callback')

          this.$message({
            message: '上傳成功',
            type: 'success',
          })
        }
      } else {
        this.$message({
          message: response.message,
          type: 'error',
        })
      }

      this.$refs.upload.clearFiles()
    },
    async beforeUpload(file) {
      let vm = this
      //覆寫auto上傳
      if (this.autoUpload) {
        let data = await vm.combineFileAndPayload()
        //debugger;
        // let resp = await request({
        //   url: vm.apiUrl,
        //   method: "post",
        //   data,
        // });
        // console.log(resp);
        vm.sendFileMsgCallback(data.fileInfo[0].files[0])
      }
      throw Error('pls ignore the error. only stoped auto upload')
      return false
    },
  },
}
</script>

<style scope>
.upload-container .el-upload {
  width: auto;
}

.el-upload-list {
  max-height: 350px;
  overflow: auto;
}
</style>
